var exports = {
  "N": "xdde3148b--91fc43--feature",
  "U": "xdde3148b--91fc43--value",
};

module.exports = exports;
